import type { SVGProps } from 'react';
export const IconServiceTBank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 40 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_19934_33815)">
      <mask
        id="mask0_19934_33815"
        style={{
          maskType: 'luminance'
        }}
        maskUnits="userSpaceOnUse"
        x={2}
        y={2}
        width={37}
        height={20}
      >
        <path
          d="M39 2H2V22H39V2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_19934_33815)">
        <path
          d="M29.0018 2H11.9982C6.47635 2 2 6.47715 2 12C2 17.5228 6.47635 22 11.9982 22H29.0018C34.5236 22 39 17.5228 39 12C39 6.47715 34.5236 2 29.0018 2Z"
          fill="#303030"
        />
        <path
          d="M7.80078 7.1416H18.5719V12.5596C18.5719 13.9486 17.8304 15.2324 16.6285 15.9269L13.1863 17.9147L9.74418 15.9269C8.54075 15.2324 7.80078 13.9486 7.80078 12.5596V7.1416Z"
          fill="#FFDD2D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7555 9.99316V11.6776C10.9864 11.4168 11.4043 11.2408 11.8835 11.2408H12.4035V13.2003C12.4035 13.722 12.2622 14.1777 12.0516 14.4291H14.3155C14.1066 14.1777 13.9652 13.722 13.9652 13.2019V11.2424H14.4852C14.9644 11.2424 15.3838 11.4184 15.6132 11.6792V9.99473H10.7539L10.7555 9.99316Z"
          fill="#333333"
        />
        <path
          d="M24.7207 15.3973V9.03027H22.7129V15.3973H24.7207Z"
          fill="white"
        />
        <path
          d="M29.5594 15.3973C32.0998 15.3973 33.3566 14.046 33.3566 12.2138C33.3566 10.3816 32.0982 9.03027 29.7731 9.03027H26.1895V15.3973H29.561H29.5594ZM29.3567 10.5545C30.7345 10.5545 31.3096 11.1704 31.3096 12.2138C31.3096 13.177 30.7361 13.9124 29.3567 13.9124H28.1266V10.5545H29.3567Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_19934_33815">
        <rect
          width={37}
          height={20}
          fill="white"
          transform="translate(2 2)"
        />
      </clipPath>
    </defs>
  </svg>
);
